'use strict';

import './component.scss';
import hasValue from './has-value';

window.addEventListener('input', event => {
    hasValue.apply(event.target);
});

window.addEventListener('change', event => {
    let input = event.target;
    if (input.nodeName === 'SELECT') {
        hasValue.apply(input);
    }
});

window.addEventListener('click', event => {
    let input = event.target;
    if (input.nodeName === 'INPUT' && (input.type === 'radio' || input.type === 'checkbox')) {
        hasValue.apply(input);
    }
});

window.addEventListener('pageshow', () => {
    let inputs = document.querySelectorAll(['input[type="color"]',
                                            'input[type="date"]',
                                            'input[type="datetime-local"]',
                                            'input[type="email"]',
                                            'input[type="month"]',
                                            'input[type="number"]',
                                            'input[type="password"]',
                                            'input[type="search"]',
                                            'input[type="tel"]',
                                            'input[type="text"]',
                                            'input[type="time"]',
                                            'input[type="url"]',
                                            'input[type="week"]',
                                            'textarea',
                                            'select'].join(','));
    for (let input of inputs) {
        hasValue.apply(input);
    }
});
